// Counts down to the end of data-end (YYYY-MM-DD) or, when blank or past, the end of the coming Sunday in the shop's offset.
class SCountdown extends HTMLElement {
  #timer;
  #units = {};

  connectedCallback() {
    for (const el of this.querySelectorAll('[data-unit]')) this.#units[el.dataset.unit] = el;
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #offsetMinutes() {
    const match = /^([+-])(\d{2})(\d{2})$/.exec(this.dataset.tzOffset || '');
    if (!match) return 0;
    const minutes = Number(match[2]) * 60 + Number(match[3]);
    return match[1] === '-' ? -minutes : minutes;
  }

  #target() {
    const offset = this.#offsetMinutes();
    const dateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec((this.dataset.end || '').trim());
    if (dateMatch) {
      const fixed = Date.UTC(Number(dateMatch[1]), Number(dateMatch[2]) - 1, Number(dateMatch[3]) + 1) - offset * 60000;
      if (fixed > Date.now()) return fixed;
    }
    // Rolling weekly: shift now into shop-local time, find the coming Monday 00:00, shift back.
    const local = new Date(Date.now() + offset * 60000);
    const daysToMonday = ((8 - local.getUTCDay()) % 7) || 7;
    return Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate() + daysToMonday) - offset * 60000;
  }

  #tick() {
    const total = Math.floor(Math.max(0, this.#target() - Date.now()) / 1000);
    const values = {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60,
    };
    for (const [unit, value] of Object.entries(values)) {
      const el = this.#units[unit];
      if (el) el.textContent = String(value).padStart(2, '0');
    }
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
